import { Container } from '@pwskills/rachnaui';
import React from 'react';
import Image from 'next/image';
import PlacementStatistics from './PlacementStatistics';
import CompanyList from './CompanyList';

const OurAchieversPlacedAt = () => {
  return (
    <section className=" bg-blue-50 relative !pt-0 !mt-0">
      <Container className="flex flex-col gap-6">
        <PlacementStatistics />
        <CompanyList />
      </Container>
      <figure className="hidden regular:!block absolute left-0 bottom-0 w-[110px] h-[160px] large:!w-[226px] large:!h-[256px] z-0">
        <Image
          src="/images/campusEdgeCourseDescription/main/trophy.svg"
          alt="trophy"
          fill
          loading="lazy"
          className="opacity-55"
        />
      </figure>
    </section>
  );
};

export default OurAchieversPlacedAt;
